import script from "./PhotographerEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotographerEvent.vue?vue&type=script&setup=true&lang=js"

import "./PhotographerEvent.vue?vue&type=style&index=0&id=2ff03680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff03680"]])

export default __exports__